import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, takeUntil, tap } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiUrls } from 'src/app/shared/const/Api-urls';
import {
  SchoolCO,
  PageCO,
  PageCategoryCO,
  PageCategoryType,
  PageContentCO
} from 'src/app/shared/models/ApiModels';
import { SchoolDetailsService } from 'src/app/shared/services/school-details.service';
import { PageDataService } from 'src/app/shared/services/page-data.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy {

  school: SchoolCO | null = null;

  instagramContent?: PageContentCO;
  facebookContent?: PageContentCO;
  youtubeContent?: PageContentCO;

  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private snackBar: MatSnackBar,
    private schoolService: SchoolDetailsService,
    private pageDataService: PageDataService
  ) {}

  ngOnInit(): void {

    this.schoolService.schoolState$
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {

        this.school = state.data;

        if (state.error) {
          this.showError(state.error);
        }
      });

    this.pageDataService.pageData$
      .pipe(
        takeUntil(this.destroy$),
        tap(data => {

          if (!data?.length) {
            return;
          }

          const page = data.find(
            page => page?.name?.toLowerCase() === 'footer'
          );

          if (!page) {
            return;
          }

          this.extractFooterData(page);
        })
      )
      .subscribe();

    this.pageDataService.loadPageData();
  }

  private extractFooterData(page: PageCO): void {

    if (!page.category?.length) {
      return;
    }

    const categoryMap = new Map<PageCategoryType, PageCategoryCO>();

    page.category.forEach(category =>
      categoryMap.set(category.category, category)
    );

    this.buildSocialLinks(categoryMap);
  }

  private buildSocialLinks(
    map: Map<PageCategoryType, PageCategoryCO>
  ): void {

    const socialLinks =
      map.get(PageCategoryType.FOOTER_SOCIAL_LINKS);

    this.instagramContent = socialLinks?.content?.find(x => x?.msgOrder === 1);
    this.facebookContent = socialLinks?.content?.find(x => x?.msgOrder === 2);
    this.youtubeContent = socialLinks?.content?.find(x => x?.msgOrder === 3);
  }

  openExternalLink(link?: string): void {

    if (!link) {
      return;
    }

    window.open(link, '_blank', 'noopener,noreferrer');
  }

  contact(): void {
    this.router.navigate(['contact']);
  }

  getFilePath(fileUUID?: string): string | null {
    return fileUUID
      ? `${ApiUrls.downloadFileUrl}${fileUUID}`
      : null;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private showError(message: string): void {
    this.snackBar.open(message, 'x', { duration: 3000 });
  }
}